/** 4.7 stars — 131×23 */
export const HeroStars = () => (
    <svg
        className="h-[23px] w-[131px] shrink-0"
        viewBox="0 0 131 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <path
            d="M11.5 0L14.0819 7.9463H22.4371L15.6776 12.8574L18.2595 20.8037L11.5 15.8926L4.74047 20.8037L7.32238 12.8574L0.56285 7.9463H8.91809L11.5 0Z"
            fill="#FFF27D"
        />
        <path
            d="M38.5 0L41.0819 7.9463H49.4371L42.6776 12.8574L45.2595 20.8037L38.5 15.8926L31.7405 20.8037L34.3224 12.8574L27.5628 7.9463H35.9181L38.5 0Z"
            fill="#FFF27D"
        />
        <path
            d="M65.5 0L68.0819 7.9463H76.4371L69.6776 12.8574L72.2595 20.8037L65.5 15.8926L58.7405 20.8037L61.3224 12.8574L54.5628 7.9463H62.9181L65.5 0Z"
            fill="#FFF27D"
        />
        <path
            d="M92.5 0L95.0819 7.9463H103.437L96.6776 12.8574L99.2595 20.8037L92.5 15.8926L85.7405 20.8037L88.3224 12.8574L81.5628 7.9463H89.9181L92.5 0Z"
            fill="#FFF27D"
        />
        <path
            d="M119.5 0L122.082 7.9463H130.437L123.678 12.8574L126.26 20.8037L119.5 15.8926L112.74 20.8037L115.322 12.8574L108.563 7.9463H116.918L119.5 0Z"
            fill="white"
        />
        <path d="M119.5 16V0L117 8H108.5L115.5 13L112.5 21L119.5 16Z" fill="#FFF27D" />
    </svg>
);

/** shield-check — outer 20×20, leaf inset 8.33% / 16.67% / 8.32% / 16.67% */
export const ShieldCheckIcon = ({ stroke = "white" }: { stroke?: string }) => (
    <span className="relative inline-block size-5 shrink-0 overflow-hidden" aria-hidden>
        <span className="absolute inset-[8.33%_16.67%_8.32%_16.67%]">
            <span className="absolute inset-[-3%_-3.75%]">
                <svg
                    className="block size-full"
                    viewBox="0 0 14.3333 17.6695"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M4.66667 8.83371L6.33333 10.5004L9.66667 7.16704M13.8333 9.66704C13.8333 13.8337 10.9167 15.917 7.45 17.1254C7.26847 17.1869 7.07128 17.1839 6.89167 17.117C3.41667 15.917 0.5 13.8337 0.5 9.66704V3.83371C0.5 3.61269 0.587798 3.40073 0.744078 3.24445C0.900358 3.08817 1.11232 3.00037 1.33333 3.00037C3 3.00037 5.08333 2.00037 6.53333 0.733708C6.70988 0.582874 6.93446 0.5 7.16667 0.5C7.39887 0.5 7.62345 0.582874 7.8 0.733708C9.25833 2.00871 11.3333 3.00037 13 3.00037C13.221 3.00037 13.433 3.08817 13.5893 3.24445C13.7455 3.40073 13.8333 3.61269 13.8333 3.83371V9.66704Z"
                        stroke={stroke}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
        </span>
    </span>
);

/** chart-line — outer 20×20, leaf inset 12.5% */
export const ChartLineIcon = ({ stroke = "white" }: { stroke?: string }) => (
    <span className="relative inline-block size-5 shrink-0 overflow-hidden" aria-hidden>
        <span className="absolute inset-[12.5%]">
            <span className="absolute inset-[-3.33%]">
                <svg
                    className="block size-full"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M0.5 0.5V13.8333C0.5 14.2754 0.675595 14.6993 0.988155 15.0118C1.30072 15.3244 1.72464 15.5 2.16667 15.5H15.5M13.8333 5.5L9.66667 9.66667L6.33333 6.33333L3.83333 8.83333"
                        stroke={stroke}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
        </span>
    </span>
);

/** banknote — outer 13.44×13.44 (desktop) / 12×12 (mobile), leaf inset 25% / 8.33% */
export const BanknoteIcon = ({ className = "size-[13.44px]" }: { className?: string }) => (
    <span className={`relative inline-block shrink-0 overflow-hidden ${className}`} aria-hidden>
        <span className="absolute bottom-1/4 left-[8.33%] right-[8.33%] top-1/4">
            <span className="absolute inset-[-6.25%_-3.75%]">
                <svg
                    className="block size-full"
                    viewBox="0 0 12.038 7.55874"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M2.65956 3.77937H2.66516M9.37844 3.77937H9.38404M1.53974 0.41993H10.4983C11.1167 0.41993 11.6181 0.921288 11.6181 1.53974V6.019C11.6181 6.63745 11.1167 7.13881 10.4983 7.13881H1.53974C0.921288 7.13881 0.41993 6.63745 0.41993 6.019V1.53974C0.41993 0.921288 0.921288 0.41993 1.53974 0.41993ZM7.13881 3.77937C7.13881 4.39783 6.63745 4.89918 6.019 4.89918C5.40054 4.89918 4.89918 4.39783 4.89918 3.77937C4.89918 3.16091 5.40054 2.65956 6.019 2.65956C6.63745 2.65956 7.13881 3.16091 7.13881 3.77937Z"
                        stroke="#F15D2A"
                        strokeWidth="0.83986"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
        </span>
    </span>
);

/** Desktop wave — 1957×1970, evenodd so only arches show */
export const HeroWaveWeb = ({ className }: { className?: string }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1440"
        height="907"
        viewBox="0 0 1440 907"
        fill="none"
        className={className}
    >
        <path
            opacity="0.04"
            d="M1701 -597H-256V1373H1701V-597ZM1467.38 -361.823V-185.304C1022.91 -104.691 654.843 197.226 479.923 603.132C359.042 434.915 182.602 309.735 -22.3753 254.901V-361.823H1467.38ZM-22.3753 553.214C207.56 646.388 370.001 872.936 370.001 1137.82H-22.3753V553.214ZM651.479 1137.82C651.479 634.264 999.909 212.737 1467.38 103.942V1137.82H651.479Z"
            fill="white"
        />
    </svg>
);

/** Mobile wave — dark navy bg, white @ 0.04 */
export const HeroWaveMobile = ({ className }: { className?: string }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="393"
        height="828"
        viewBox="0 0 393 828"
        fill="none"
        className={className}
    >
        <path
            opacity="0.04"
            d="M801 -127H-242V953H801V-127ZM676.488 1.92931V98.7011C439.608 142.895 243.442 308.413 150.217 530.941C85.7917 438.72 -8.24309 370.093 -117.488 340.032V1.92931H676.488ZM-117.488 503.574C5.05829 554.655 91.6328 678.853 91.6328 824.071H-117.488V503.574ZM241.649 824.071C241.649 548.008 427.348 316.917 676.488 257.273V824.071H241.649Z"
            fill="white"
        />
    </svg>
);

/** Mobile wave light bg — Figma 2541:36003, #E6E6E6 @ 0.51 */
export const HeroWaveMobileLight = ({ className }: { className?: string }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1043"
        height="1080"
        viewBox="0 0 1043 1080"
        fill="none"
        className={className}
        aria-hidden
    >
        <path
            opacity="0.51"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1043 0H0V1080H1043V0ZM918.488 128.929V225.701C681.608 269.895 485.442 435.413 392.217 657.941C327.792 565.72 233.757 497.093 124.512 467.032V128.929H918.488ZM124.512 630.574C247.058 681.655 333.633 805.853 333.633 951.071H124.512V630.574ZM483.649 951.071C483.649 675.008 669.348 443.917 918.488 384.273V951.071H483.649Z"
            fill="#E6E6E6"
        />
    </svg>
);

/** Ellipse 8 — outer 463×463, leaf inset -107.99% (1463 blur) */
export const HeroGlowOrange = ({ filterId }: { filterId: string }) => (
    <span className="pointer-events-none absolute inset-[-107.99%]" aria-hidden>
        <svg
            className="block size-full max-w-none"
            viewBox="0 0 1463 1463"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g opacity="0.86" filter={`url(#${filterId})`}>
                <circle cx="731.5" cy="731.5" r="231.5" fill="#F47843" />
            </g>
            <defs>
                <filter
                    id={filterId}
                    x="0"
                    y="0"
                    width="1463"
                    height="1463"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur stdDeviation="250" result="effect1_foregroundBlur" />
                </filter>
            </defs>
        </svg>
    </span>
);

/** Ellipse 9 desktop — outer 463×463, leaf inset -86.39% (1263 blur) */
export const HeroGlowBlueWeb = () => (
    <span className="pointer-events-none absolute inset-[-86.39%]" aria-hidden>
        <svg
            className="block size-full max-w-none"
            viewBox="0 0 1263 1263"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#hero-glow-blue-web)">
                <circle cx="631.5" cy="631.5" r="231.5" fill="#375ED9" />
            </g>
            <defs>
                <filter
                    id="hero-glow-blue-web"
                    x="0"
                    y="0"
                    width="1263"
                    height="1263"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur stdDeviation="200" result="effect1_foregroundBlur" />
                </filter>
            </defs>
        </svg>
    </span>
);

/** Ellipse 9 mobile — outer 329×329, leaf inset -60.79% (729 blur) */
export const HeroGlowBlueMobile = () => (
    <span className="pointer-events-none absolute inset-[-60.79%]" aria-hidden>
        <svg
            className="block size-full max-w-none"
            viewBox="0 0 729 729"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#hero-glow-blue-mobile)">
                <circle cx="364.5" cy="364.5" r="164.5" fill="#375ED9" />
            </g>
            <defs>
                <filter
                    id="hero-glow-blue-mobile"
                    x="0"
                    y="0"
                    width="729"
                    height="729"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur stdDeviation="100" result="effect1_foregroundBlur" />
                </filter>
            </defs>
        </svg>
    </span>
);
